import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import {
  type SearchMultipleSelectionProps,
  SearchMultipleSelection,
} from '../SearchMultipleSelection';

type FormSearchMultipleSelectionProps<TFieldValues extends FieldValues> =
  UseControllerProps<TFieldValues> & SearchMultipleSelectionProps;

function FormSearchMultipleSelection<TFieldValues extends FieldValues = FieldValues>(
  props: FormSearchMultipleSelectionProps<TFieldValues>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <SearchMultipleSelection
      {...field}
      {...props}
      error={!!error}
      required={props?.required ?? !!props.rules?.required}
      helperText={error?.message ?? props.helperText ?? null}
      onChange={props.onChange ?? ((event, item) => field.onChange(item ?? null))}
      onBlur={field.onBlur}
      inputRef={ref}
    />
  );
}

export type { FormSearchMultipleSelectionProps };
export { FormSearchMultipleSelection };
